import { useMemo } from "react";
import { AppButton } from "../../../../../../shared/components/AppButton";
import styles from "./styles.module.css";

interface Props {
  activeMenu: boolean;
  anchorEl: HTMLElement | null;
  disabledAddVisibleLink: boolean;
  handleTargetLink: (e: any) => void;
  handleMakeLinkVisible: () => void;
}

export const LinksMenu = ({
  activeMenu,
  anchorEl,
  disabledAddVisibleLink,
  handleTargetLink,
  handleMakeLinkVisible,
}: Props) => {
  const rect = useMemo(() => {
    if (!anchorEl) return;
    return anchorEl.getBoundingClientRect();
  }, [anchorEl]);

  const handleAddLink = () => {
    handleMakeLinkVisible();
  };

  const handleTarget = (e: any) => {
    handleTargetLink(e);
  };

  return (
    <>
      {activeMenu && (
        <div
          className={styles["nav-menu"]}
          style={{
            position: "fixed",
            top: rect ? rect.top : 0,
            left: rect ? rect.left + 240 : 0,
          }}
        >
          <AppButton
            buttonType={"text"}
            disabled={disabledAddVisibleLink}
            onClick={handleAddLink}
            className={styles["menu-item"]}
          >
            Отобразить сервис
          </AppButton>
          <div onClick={handleTarget} className={styles["menu-item"]}>
            Перейти к сервису
          </div>
        </div>
      )}
    </>
  );
};
